import { createRoutine } from 'redux-saga-routines'

export const SET = 'COLABORA_LAYOUT/SET'
export const CONTENT = createRoutine('COLABORA_LAYOUT/CONTENT')
